import LogoText from './logo_text';

export default LogoText;
